export enum CalendarType {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
}
